import * as React from 'react';
import { connect } from 'react-redux';
import { ConfirmSchedule } from '../../components/pages/ConfirmSchedule';
import constants from '../../constants';
import { IApplicationState } from '../../store';
import { ActionCreators as ConfirmScheduleActionCreators } from '../../store/ConfirmScheduleStore';
import { ActionCreators as SurveyBuilderActionCreators } from '../../store/SurveyBuilderStore';
import { ConfirmPageStateSetter } from '../state-setter/ConfirmPageStateSetter';
import { PageStateSetterRouteProps } from '../state-setter/SurveyPageStateSetterBase';

export const ConfirmScheduleContainer: React.ComponentType<any> = connect(
	(state: IApplicationState) => ({
		...state.confirmSchedule,
		...state.surveyBuilder,
		isSurveyTemplate: state.survey.surveyEditModel.survey.clientId === constants.SYSTEM_CLIENT_ID,
	}),
	{ ...SurveyBuilderActionCreators, ...ConfirmScheduleActionCreators },
)(ConfirmSchedule);

export class ConfirmSchedulePage extends React.PureComponent<PageStateSetterRouteProps> {
	public render() {
		return (
			<>
				<ConfirmScheduleContainer {...this.props} />
				<ConfirmPageStateSetter {...this.props} />
			</>
		);
	}
}
